import Doughnut from "../../../components/charts/Doughnut/Doughnut";
import BarChart from "../../../components/charts/bar/bar-chart";
import Header from "../../../components/header/header";
import DataDetails from "../data-details/data-details";
import DataTable from "../data-table/data-table";
import Admin from "../../dashboard/admin/admin";
import "./main.css";

function HomeMain() {
    return (
        <div className="main-section">
             <Header />
            {/* <Admin />*/}
           
        </div>
    )
};

export default HomeMain;